import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    react: {
      useSuspense: true // or false if you're managing readiness manually
    },
    supportedLngs: ['en', 'he'],
    preload: ['he', 'en'],
    fallbackLng: 'he',
    load: 'languageOnly',
    debug: false,
    ns: [
      'routes-and-main-menu',
      'bottom-menu-and-settings',
      'invite-modal',
      'join-modal',
      'leave-community-modal',
      'location-settings-content',
      'modal-action-buttons',
      'my-community-card',
      'pause-community-modal',
      'pricelist-additional-information',
      'pricelist-header-content',
      'pricelist-info',
      'pricelist-modal',
      'pricelist-search',
      'price-services-steps',
      'remove-supplier-modal',
      'single-service-accordion',
      'supplier-accepted-modal',
      'supplier-info',
      'supplier-profile-header',
      'supplier-profile-modal',
      'supplier-products-info',
      'page-business-settings',
      'active-order-modal',
      'close-pricelist-dialog',
      'page-manage-communities',
      'page-community-settings',
      'page-find-communities',
      'page-find-new-suppliers',
      'page-manage-pricelists',
      'page-my-community-members',
      'page-my-suppliers',
      'my-members-card',
      'discard-changes-modal',
      'supplier-join-offers-modal',
      'delete-deactivate-pricelist',
      'missing-service-modal',
      'profile-drawer',
      'community-card',
      'delete-account',
      // Service categories. The catalog verticals each have their own category
      // tree and therefore their own namespace — see categoryNamespaces.js.
      "categories",
      "products_categories",
      "restaurants_categories",
      "services",
      "services-description",
      "sku",
      "sku-description",
      "sku-more-info-text",
      "units",
      "districts",
      "components",
      "welcome",
      "pricelist-created",
      "need-pricelist",
      "join-request-received",
      "validation-error-messages",
      "dropdowns",
      "header-filters",
      "my-communities",
      "maximum-capacity-reached",
      "tos-modal",
      "page-my-jobs",
      "page-dashboard",
      "page-supplier-dashboard",
      "page-communities",
      "job-action-modals",
      "view-job-modal",
      "tooltip-sections",
      "custom-tooltip-box",
      "notifications",
      // Hand-maintained notification UI chrome, kept in a SEPARATE namespace so
      // the auto-generated notifications.json (templates only, from the
      // spreadsheet export) can be overwritten without wiping these strings.
      "notifications-ui"
    ]
    ,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: false // Disable auto-detection since we'll handle language changes via API
  });

export default i18n;
